import React, { Component } from 'react'
import SWTWorkDocDamageFasttrack from '../workdoc/SWTWorkDocDamageFasttrack'
import { ControlLabel, InputGroup, FormGroup, Row, Col, FormControl } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { Button } from 'react-date-picker/lib/Footer';

class QuotationDoc extends Component {

  constructor(props) {
    super(props)

    this.state = {showCar:false,doc:this.getEmptyDoc()}
  }

  getEmptyDoc() {
    return {work_no:undefined,customer_name:'',customer_address:'',customer_tel:'',status:'0',car_detail:'',date:'',remark:''}
  }

  loadData(workNo) {
    let {doc} = this.state
    doc.work_no = workNo
    this.setState({doc:doc})  
    setTimeout(()=>{
        this.refs.swtWorkDocFasttack.loadData()
    },100)
  }

  onDocClose() {
      this.props.onClose()
  }

  onInputChange(key,e) {
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onShowCarClick() {
      let {showCar} = this.state
      if (showCar)
        showCar = false
      else
        showCar = true

      this.setState({showCar:showCar})
  }

  renderRemark() {
    let {doc} = this.state
    return (
        <Col md={3}>
          <FormGroup
            controlId="formBasicText"
            validationState={null}
          >
            <ControlLabel>หมายเหตุ </ControlLabel>
              <FormControl rows={5} value={doc.remark} componentClass="textarea" style={{width:'100%'}} onChange={this.onInputChange.bind(this, 'remark')} />
          </FormGroup>
        </Col>
    )
  }

  renderHeader() {
      let {doc,showCar} = this.state
      return(
        <div>
            <Row>
                <Col md={3}>
                    <FormGroup
                        controlId="formBasicText"
                        validationState={null}
                    >
                        <ControlLabel>ชื่อลูกค้า :</ControlLabel>
                        <InputGroup>
                            <InputGroup.Addon><FontAwesome name='user' /></InputGroup.Addon>
                            <FormControl value={doc.customer_name} onChange={this.onInputChange.bind(this, 'customer_name')} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup
                        controlId="formBasicText"
                        validationState={null}
                    >
                        <ControlLabel>ที่อยู่ :</ControlLabel>
                        <InputGroup>
                            <InputGroup.Addon><FontAwesome name='home' /></InputGroup.Addon>
                            <FormControl value={doc.customer_address} onChange={this.onInputChange.bind(this, 'customer_address')} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup
                        controlId="formBasicText"
                        validationState={null}
                    >
                        <ControlLabel>เบอร์โทร :</ControlLabel>
                        <InputGroup>
                            <InputGroup.Addon><FontAwesome name='phone' /></InputGroup.Addon>
                            <FormControl value={doc.customer_tel} onChange={this.onInputChange.bind(this, 'customer_tel')} />
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <FormGroup
                        controlId="formBasicText"
                        validationState={null}
                    >
                        <ControlLabel>หมายเลขรับแจ้ง/ใบงาน :</ControlLabel>
                        <div style={{marginBottom:'5px'}}>
                            <span>สถานะ</span>&nbsp;
                            <span className='label label-default'>เริ่มต้น</span>&nbsp;
                            <span style={{cursor:'pointer'}} className='label label-default'>คลิ๊กเข้าดู</span>
                        </div>
                        <InputGroup>
                            <InputGroup.Addon><FontAwesome name='file' /></InputGroup.Addon>
                            <FormControl value={doc.work_no} readOnly={true} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup
                        controlId="formBasicText"
                        validationState={null}
                    >
                        <ControlLabel>ข้อมูลรถยนต์ : <Button className='btn btn-xs btn-default' onClick={this.onShowCarClick.bind(this)}><FontAwesome name='pencil'/>&nbsp;แก้ไขข้อมูลรถ</Button></ControlLabel>
                        <div style={{display:(showCar?'':'none')}}>
                            <Row>
                                <Col md={3}>
                                    <FormGroup
                                        controlId="formBasicText"
                                        validationState={null}
                                    >
                                        <ControlLabel>ยี่ห้อ :</ControlLabel>
                                        <FormControl value={''} />
                                    </FormGroup>    
                                </Col>
                                <Col md={3}>
                                    <FormGroup
                                        controlId="formBasicText"
                                        validationState={null}
                                    >
                                        <ControlLabel>สี :</ControlLabel>
                                        <FormControl value={''} />
                                    </FormGroup>    
                                </Col>
                                <Col md={3}>
                                    <FormGroup
                                        controlId="formBasicText"
                                        validationState={null}
                                    >
                                        <ControlLabel>รุ่น :</ControlLabel>
                                        <FormControl value={''} />
                                    </FormGroup>    
                                </Col>
                                <Col md={3}>
                                    <FormGroup
                                        controlId="formBasicText"
                                        validationState={null}
                                    >
                                        <ControlLabel>เลขทะเทียน :</ControlLabel>
                                        <FormControl value={''} />
                                    </FormGroup>    
                                </Col>
                            </Row>
                        </div>
                        <InputGroup>
                            <InputGroup.Addon><FontAwesome name='car' /></InputGroup.Addon>
                            <FormControl value={doc.car_detail} readOnly={true} />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup
                        controlId="formBasicText"
                        validationState={null}
                    >
                        <ControlLabel>วันที่ :</ControlLabel>
                        <InputGroup>
                            <InputGroup.Addon><FontAwesome name='calendar' /></InputGroup.Addon>
                            <FormControl value={doc.date} readOnly={true} />
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>    
        </div>        
      )
  }

  render() {
  	return(
  		<div>
            <SWTWorkDocDamageFasttrack
                ref={'swtWorkDocFasttack'}
                dn={'QuotationDoc'}
                workNo={this.state.doc.work_no}
                onRenderHeader={this.renderHeader.bind(this)}
                onRenderRemark={this.renderRemark.bind(this)}
                onDocClose={this.onDocClose.bind(this)}
            />
  		</div>
  	)
  }

}
 
export default QuotationDoc;



// WEBPACK FOOTER //
// ./src/view/qo/QuotationDoc.js